module.exports = __webpack_public_path__ + "img/cover-outer.b7cc5093.png";